import React from 'react';
import './Aboutartist.css'
import artistImg from '../../assets/priya_pratap.jpeg'; // Update path

const AboutArtist = () => {
  return (
    <div className="about-artist">
      <div className="artist-image">
        <img src={artistImg} alt="Priya Pratap" />
      </div>
      <div className="artist-text">
        <h2>About Priya Pratap</h2>
        <p>
        Priya Pratap is the founder and creative mind behind Priya Pratap Makeup Studio, a premier beauty destination in Bijnor known for stunning makeovers and exceptional service. With a passion for makeup that started as a personal interest, Priya turned her love for beauty into a thriving professional career, mastering the art of bridal transformations, party makeup, editorial looks, and customized beauty services.
        </p>
           <p>
Her studio is celebrated for its attention to detail, high-quality products, and personalized approach that ensures every client feels confident, beautiful, and camera-ready. Over the years, Priya has built a loyal clientele who trust her for everything from elegant bridal makeovers to glamorous party looks.
        </p>
           <p>
Under her leadership, Priya Pratap Makeup Studio has become a one-stop destination offering bridal makeup, nail art, hair styling, skincare consultations, and professional beauty services—all delivered with creativity, precision, and a personal touch.
        </p>
      </div>
    </div>
  );
};

export default AboutArtist;
